import { render, staticRenderFns } from "./FrageTable.vue?vue&type=template&id=e0520e58&scoped=true"
import script from "./FrageTable.vue?vue&type=script&lang=js"
export * from "./FrageTable.vue?vue&type=script&lang=js"
import style0 from "./FrageTable.vue?vue&type=style&index=0&id=e0520e58&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0520e58",
  null
  
)

export default component.exports